import { PropsWithChildren } from 'react';

export const OrderedList = ({ children }: PropsWithChildren) => {
  return (
    <ol className="mb-4 list-decimal pl-8" data-testid="ol-markup">
      {children}
    </ol>
  );
};
